import { render } from "./addMenu.vue?vue&type=template&id=4dff4385&scoped=true"
import script from "./addMenu.vue?vue&type=script&lang=js"
export * from "./addMenu.vue?vue&type=script&lang=js"

import "./addMenu.vue?vue&type=style&index=0&id=4dff4385&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dff4385"]])

export default __exports__